import home from 'modules/home'
import CGSPage from 'pages/cgs'

import { RouteObject } from 'react-router-dom'

export const publicRoutes: RouteObject[] = [
  { path: '/cgs', element: <CGSPage /> },
]
